import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Team } from './team.interface';
import teamService from './team.service';

export interface TeamState {
   teams?: Array<Team>;
}

const TeamStore: Module<TeamState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async get(context, { set_as_state = true, company_id, search }) {
         return await teamService.get(company_id, search).then((response) => {
            return response.data;
         });
      },
      async search(context, { tenant_id, search }) {
         return await teamService.search(tenant_id, search).then((response) => {
            return response.data;
         });
      },
   },
};

export default TeamStore;
